import {
  GROUP_TYPE,
  ISuggestedClinicianData,
} from "@home-health-notify/domain";
import { Box, Typography } from "@mui/material";
import {
  getMilesFromMeters,
  useFetchChatInfo,
  useTranslation,
} from "hhn-commons";
import { useContext } from "react";
import { UserTitle } from "../../../../common/user/UserText";
import { RightDrawerContext } from "../../../../context/RightDrawerContext";
import { ClinicianName, SmartContentItemDetails } from "./SmartContent.style";

export const ClinicianDetails = ({
  clinicianData,
  inReferralModal,
}: {
  clinicianData: ISuggestedClinicianData;
  inReferralModal?: boolean;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  const { openChatInfoDrawer } = useContext(RightDrawerContext);
  const { setChatInfoContext } = useFetchChatInfo();

  const openChatInfo = async () => {
    openChatInfoDrawer();
    // Setting chat info context for the clinician's private chat
    await setChatInfoContext(clinicianData.id, GROUP_TYPE.PRIVATE);
  };

  return (
    <SmartContentItemDetails>
      <ClinicianName
        data-testid={
          inReferralModal ? "clinician-name-modal" : "clinician-name"
        }
        onClick={openChatInfo}
        sx={{
          fontSize: inReferralModal ? "large" : "medium",
          cursor: "pointer",
        }}
      >
        <UserTitle userId={clinicianData.id} />
      </ClinicianName>
      <Typography
        component={"span"}
        data-testid={
          inReferralModal ? "nearby-patients-modal" : "nearby-patients-qty"
        }
      >
        {tNs("smartContent.patientsNearby")}
        <Box
          sx={{
            fontWeight: "fontWeightMedium",
            display: "inline",
          }}
        >
          {clinicianData.patients.length}
        </Box>
      </Typography>
      <Typography
        component={"span"}
        data-testid={
          inReferralModal
            ? "closest-nearby-patient-modal"
            : "closest-nearby-patient"
        }
      >
        {tNs("smartContent.closestPatient")}
        <Box
          sx={{
            fontWeight: "fontWeightMedium",
            display: "inline",
          }}
        >
          {getMilesFromMeters(clinicianData.patients[0].distance)}{" "}
          {tNs("smartContent.miles")}
        </Box>
      </Typography>
    </SmartContentItemDetails>
  );
};
